/* eslint-disable no-unused-vars */

import React from "react";
import { useNavigate } from "react-router-dom";
const PopupSuccessNote = (props) => {
  const navigate = useNavigate();
  const closeModal = () => {
    props.setModalInput(false);
    document.body.classList.remove("modal-open");
  };
  return (
    <>
      <div className="popup-overlay ">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="icon-popup"></div>
            <h3 className="name-popup">Thông báo</h3>
            <div className="content-popup">
              <img
                className="img-animation"
                src="assets/img/giftsend.png"
                alt="200.png"
              />
              <p>Bạn chắc chắn muốn gửi lời chúc và bài hát này chứ?</p>
              <p>
                (Sau khi bấm “Gửi ngay”, bạn sẽ không thể thay đổi nội dung lời
                chúc)
              </p>
            </div>

            <div className="group-btn-inline">
              <button
                type="button"
                className="btn btn-primary btn-border btn-block"
                onClick={props.clickAction}
              >
                Hủy bỏ
              </button>
              <button
                type="button"
                className="btn btn-primary btn-block"
                onClick={props.clickAction1}
              >
                Gửi ngay
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PopupSuccessNote;
